import { render, staticRenderFns } from "./BookingInsurance.vue?vue&type=template&id=ec6b246e&scoped=true"
import script from "./BookingInsurance.vue?vue&type=script&lang=js"
export * from "./BookingInsurance.vue?vue&type=script&lang=js"
import style0 from "./BookingInsurance.vue?vue&type=style&index=0&id=ec6b246e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec6b246e",
  null
  
)

export default component.exports